export default {
      id: "event-passes-header-usage",
      viewBox: "0 0 64 65",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-passes-header",
      toString: function () {
        return this.url;
      }
    }